import { useRef, useState } from "react";
import PageTitle from "../../../../components/partials/PageTitle"
import ReportFilter from "../CustomerReport/ReportFilter"

const SavingsInterestReport = () => {

  const CCPdfRef = useRef();

    const [filterData, setFilterData] = useState();
    const [filteredItem, setFilteredItem] = useState(false);

    const breadcrumb = {
        from: {
          title: "Savings Policy Report",
          link: "/admin/reports/savings-policy-report",
        },
        current: {
          title: "Interest Report",
          link: null,
        },
    };

    const customerOverviewData = []
  return (
    <div>
        {/* page title */}
        <PageTitle title='Interest Report' breadcrumb={breadcrumb} />
        {/* end page title */}
        <div className='row card p-1' style={{ margin: "auto 1px" }}>
            <ReportFilter
                page={"savingsInterest"}
                setFilterData={setFilterData}
                setFilteredItem={setFilteredItem}
                filteredItem={filteredItem}
            />
          {customerOverviewData && (
                  <div className='row mb-3'>
                    <>
                      {/* <div className='d-flex justify-content-end align-items-center'>
                        <div className=' d-flex align-items-center border '>
                          <span
                            className='bg-info me-2 text-white'
                            style={{ padding: "3px" }}
                          >
                            Export to
                          </span>
        
                          <span
                            href='#'
                            id='btnExport'
                            className='me-1 cursor-p'
                            title='Export to Pdf'
                            onClick={generatePDF}
                          >
                            <img
                              src={pdf}
                              alt='export-pdf'
                              style={{ height: "25px" }}
                            />
                          </span>
                          {customerOverviewData ? (
                            <CSVLink
                              data={processedData}
                              headers={headers}
                              style={{ fontWeight: "bolder", cursor: "pointer" }}
                              filename='Customer Policy Information'
                            >
                              <span
                                href='#'
                                id='btnExport'
                                className='mr-1'
                                title='Export to Excel'
                              >
                                <img
                                  src={excel}
                                  alt='export-excel'
                                  style={{ height: "25px", marginRight: "5px" }}
                                />
                              </span>
                            </CSVLink>
                          ) : null}
                        </div>
                      </div> */}
                      <div className='table-responsive'>
                        <table
                          className='table table-centered table-striped nowrap w-100 no-footer'
                          ref={CCPdfRef}
                        >
                          <thead>
                            <tr>
                              <th
                                className='sorting'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "100.8px" }}
                                aria-label='Email: activate to sort column ascending'
                              >
                                Account Id
                              </th>
                              <th
                                className='sorting'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "100.8px" }}
                                aria-label='Email: activate to sort column ascending'
                              >
                                Total balance per product
                              </th>
                              <th
                                className='sorting'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "150.8px" }}
                                aria-label='Customer: activate to sort column ascending'
                              >
                                Average balance per product
                              </th>
                              <th
                                className='sorting'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "120.8px" }}
                                aria-label='Status: activate to sort column ascending'
                              >
                                Agent
                              </th>
                              <th
                                className='sorting'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "120.8px" }}
                                aria-label='Status: activate to sort column ascending'
                              >
                                Office
                              </th>
                            </tr>
                          </thead>
                          {customerOverviewData?.length ? (
                            <tbody>
                              {customerOverviewData?.map((item, i) => (
                                <tr key={i}>
                                  <td className='text-dark'>
                                    {item?.policy_application_number}
                                  </td>
                                  <td className='text-dark'>{item?.customer_id}</td>
                                  <td className='table-user'>
                                    <span className='text-body fw-semibold'>
                                      {item?.first_name} {item?.last_name}
                                    </span>
                                  </td>
                                  <td>
                                    {item?.agent_firstname + " "}
                                    {item?.agent_lastname}
                                  </td>
                                  <td>{item?.office_name}</td>
                                </tr>
                              ))}
                            </tbody>
                          ) : null}
                        </table>
                        {customerOverviewData?.length < 1 ? (
                          <h5 className='alert alert-info'>No result found!</h5>
                        ) : null}
                      </div>
                    </>
                  </div>
                )}
        </div>
    </div>
  )
}

export default SavingsInterestReport